import { apiWrapper, apiCancel } from '../../wrapper'

export const initial = 'employeeWFH'
const baseUrl = process.env.REACT_APP_SERVICE_CORE_URL
const appCode = process.env.REACT_APP_SERVICE_CORE_APPCODE
const outputType = 'json'

export const employeeWFHCreate = 'Kepegawaian/PengajuanWFH/create/'
export const employeeWFHList = 'Kepegawaian/PengajuanWFH/list/'
export const employeeWFHDetail = 'Kepegawaian/PengajuanWFH/detail/'
export const employeeWFHUpdate = 'Kepegawaian/PengajuanWFH/update/'
export const employeeWFHInactive = 'Kepegawaian/PengajuanWFH/inactive/'
export const employeeWFHActive = 'Kepegawaian/PengajuanWFH/active/'
export const employeeWFHApprove = 'Kepegawaian/PengajuanWFH/approve/'
export const employeeList = 'Kepegawaian/PengajuanWFH/listEmployee/'
export const employeeWFHListdetail = 'Kepegawaian/PengajuanWFH/listdetail/'

export const employeeWFHCheckDate = 'Kepegawaian/PengajuanWFH/checkDate/'
export const employeeWFHCheckNumber = 'Kepegawaian/PengajuanWFH/checkNumber/'

export const employeeWFHReport = 'Kepegawaian/PengajuanWFH/report/'
export const employeeWFHReportSend = 'Kepegawaian/PengajuanWFH/reportSend/'
export const employeeWFHReportApproval = 'Kepegawaian/PengajuanWFH/reportApproval/'
export const detailDate = 'Kepegawaian/PengajuanWFH/detailDate/'
export const getAtasan = 'Kepegawaian/PengajuanWFH/getAtasan/'

export const getMaxDate = 'Kepegawaian/PengajuanWFH/getMinDate/'

//export const cancelToken = () => apiCancel
export const cancelToken = () => {
    return apiCancel()
}
export const apiRequest = async (method, route, data = { params: null, body: null, cancelToken: null }, needToken=true) => {
    if(needToken) {
        const thisTime = (Math.floor(Date.now()/1000))
        const expire = localStorage.getItem(initial + 'accessExpired')
        if(expire < thisTime) {
           await apiWrapper(baseUrl, initial, appCode, outputType, 'post', 'auth/getAccessToken/', data)
           .then(result => {
                localStorage.setItem(initial + 'accessToken', result.response.access_token)
                return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
            })
            .catch(result => {
                return Promise.reject('Tidak dapat mengambil accessToken');
            })
        } else {
            return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)        
        }
    }
    return apiWrapper(baseUrl, initial, appCode, outputType, method, route, data)
}